import { render, staticRenderFns } from "./AIContents.vue?vue&type=template&id=137d505c"
import script from "./AIContents.vue?vue&type=script&lang=js"
export * from "./AIContents.vue?vue&type=script&lang=js"
import style0 from "./AIContents.vue?vue&type=style&index=0&id=137d505c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports